import { createFileRoute } from '@tanstack/react-router';
import { Home } from '@/features/consumer/home';

export const Route = createFileRoute('/(consumer)/_public/home')({
  component: Home,
});
